import React from "react";
import "./formSpreeForm.scss";


export default function FormSpreeForm ({handleInput,valid,handleSubmit}){
    const isValid =(field,overRide = true)=> field || (field===null&&overRide) ? "valid" : "invalid";
    const {email,name,message} = valid;
    return (
        <form onSubmit={handleSubmit}>
            <label htmlFor="name">
                name :
                <br/>
                <input
                    type="text"
                    name="name"
                    className={isValid(name)}
                    onInput={handleInput}
                    id="name"
                    placeholder=""
                />
            </label>
            <label htmlFor="email">
                email :
                <br/>
                <input
                    onInput={handleInput}
                    type="text"
                    id="email"
                    name="_replyto"
                    className={isValid(email)}
                    placeholder=""
                />
            </label>
            <label htmlFor="message">
                message :
                <br/>
                <textarea id={"message"} className={isValid(message)} onInput={handleInput} name={"text-area"} placeholder={""} />
            </label>
            <input type="text" name="_gotcha" style={{display:"none"}}/>
            <hr className={"mobile-only spaced-out"}/>
            <button
                type={"submit"}
                formAction={"submit"}
                id={"button"}
                disabled={!(email&&name&&message)}
            >
                SEND
            </button>
        </form>
    )

}